module.exports = __webpack_public_path__ + "static/media/NewIcon.e2cdda9f.svg";